import { useThrottle } from 'app/agriculture/hooks/useThrottle/useThrottle';
import { useMemo } from 'react';
import { TZDate } from '@date-fns/tz';
import { useTimeZone } from 'app/agriculture/hooks/useTimeZone/useTimeZone';

interface Params {
    /**
     * How often now should update
     * @default 1000 * 60 (i.e. 1 minute)
     */
    throttleDelay?: number;
}

export function useThrottledNow({ throttleDelay = 1000 * 60 }: Params = {}) {
    const { timeZone } = useTimeZone();
    const now = new Date();
    const throttledNow = useThrottle(now, throttleDelay);

    return useMemo(() => new TZDate(throttledNow, timeZone), [throttledNow, timeZone]);
}
